//====================================================
//  Initialization Tabs
//====================================================
function fn_components_tabs(){
	fn_tabs();
}

function fn_tabs(){
	if ($('.tabs').length){
		$( ".tabs .item" ).click(function() {
	        var inst = $(this);
	        var thisId = inst.attr('id');
	        var thisTabs = $(this).closest('.tab-block');

	        if(thisId == 'undefined'){
	        	return false;
	        }
	        
	        if (!inst.hasClass('active')){
	            thisTabs.find( ".tabs .item.active").removeClass('active');
	            $(this).addClass('active');
	            thisTabs.find(" .tabs-content .item-block.active" ).removeClass('active');
	            thisTabs.find('.tabs-content .item-block[data-id="'+ thisId + '"]').addClass('active');
	            if ($(window).width() < 550){
	            	var heightMessage = 0;
	            	var heightHeader = 0;
	            	if($('.message-box').length) {
                        heightMessage = $('.message-box').innerHeight();
                    }
	            	if($('header').length) {
                        heightHeader = $('header').innerHeight();
                    }
	            	var height = heightMessage + heightHeader;
	            	$('html, body').stop().animate({
	                    scrollTop: $('.navigation-menu-mobile .tabs-content').offset().top - height
	                }), 500 ;
	            }
	        } else{
	            thisTabs.find( ".tabs .item.active").removeClass('active');
	            thisTabs.find(" .tabs-content .item-block.active" ).removeClass('active');
	        }
	    });
	}
}

